const resources = {
    shopByCategory: 'Shop by Category',
    shop: 'Shop'
};

export default function getResource(label) {
    return resources[label];
}
